import {memo} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {AuthorizationInfo, ClientReportSubmitInput} from "../domain";
import {SimpleDropdown} from "common";

type AuthorizationInputProps = {
    authorizationList: AuthorizationInfo[];
    callback: (auth: AuthorizationInfo) => void;
    sending: boolean;
};
export const AuthorizationInput = memo(({
                                            authorizationList,
                                            callback,
                                            sending
                                        }: AuthorizationInputProps) => {
    const {
        setValue,
        clearErrors,
        control,
        formState: {
            errors
        },
    } = useFormContext<ClientReportSubmitInput>();

    const options = new Map<string, string>(authorizationList.map((authorization) => [authorization.guid, authorization.bhpnAuthNumber]));

    return (
        <div>
            <div className="flex text-black-200 pb-2 items-center text-base">
                <div className="w-2/6 text-right">
                    Authorization
                </div>
                <div className="ml-4 flex items-center">
                    <Controller
                        name="authorizationGuid"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={({field: {value}}) =>
                            <SimpleDropdown
                                options={options}
                                selected={value}
                                disabled={sending}
                                hasErrorBorder={errors.authorizationGuid !== undefined}
                                setSelected={(selected) => {
                                    setValue("authorizationGuid", selected);
                                    callback(
                                        authorizationList.find((auth) => auth.guid === selected)!)
                                    clearErrors("authorizationGuid");
                                }}
                                textColor={"black-200"}
                            />
                        }/>
                </div>
            </div>
            {
                errors.authorizationGuid &&
                <div className="flex">
                    <div className="w-2/6"/>
                    <div className="ml-4 text-red-700">
                        Please select the authorization this report corresponds to
                    </div>
                </div>
            }
        </div>
    );
});
